"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveSuitableVehicleModelsOptions = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let RetrieveSuitableVehicleModelsOptions = class RetrieveSuitableVehicleModelsOptions {
};
exports.RetrieveSuitableVehicleModelsOptions = RetrieveSuitableVehicleModelsOptions;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveSuitableVehicleModelsOptions.prototype, "approvedForCountryIds", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveSuitableVehicleModelsOptions.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveSuitableVehicleModelsOptions.prototype, "requiredVehicleCapacity", void 0);
exports.RetrieveSuitableVehicleModelsOptions = RetrieveSuitableVehicleModelsOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveSuitableVehicleModelsOptions);
//# sourceMappingURL=RetrieveSuitableVehicleModelsOptions.js.map